import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  styled
} from '@mui/material'
import TablaServerPagination from '../../../components/Common/utils/paginator/serverPaginator'
import { PaginatorRes } from '../../Pedidos/context/pedidos.context'
import { AnuncioDTO, IAnunciante } from '../types/anuncios.types'
import NoSearch from '../../../components/Common/NoSearch'
import NoResults from '../../../components/Common/NoResults'
import { format, parse } from 'date-fns'
import { es } from 'date-fns/locale'

export const TableTitle = styled('h5')({
  margin: 0,
  fontWeight: 'bold'
})

export const TABLE_HEAD_ITEMS = [
  { key: 'idAnuncio', label: 'ID' },
  { key: 'idTipoAnuncio', label: 'Tipo anuncio' },
  { key: 'idAnunciante', label: 'Anunciante' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'fecha', label: 'Fecha' },
  { key: 'activo', label: 'Activo' },
  { key: '', label: 'Acciones' }
]

export interface AnunciosProps {
  loading: boolean
  anuncios: AnuncioDTO[]
  paginator: PaginatorRes
  tiposAnucio: { id: number; nombre: string }[]
  anunciantes: IAnunciante[]
  searching: boolean
  handleUpdate: (idAnunciante: number) => Promise<void>
  handleDelete: (idAnunciante: number) => Promise<void>
}

const TablaAnuncios = ({
  loading,
  anuncios,
  paginator,
  tiposAnucio,
  anunciantes,
  searching,
  handleUpdate,
  handleDelete
}: AnunciosProps) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        maxWidth: 1280,
        mx: 'auto',
        my: 2
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {TABLE_HEAD_ITEMS.map((item, i) => (
              <TableCell key={item.key}>
                <TableTitle>{item.label}</TableTitle>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {anuncios?.length <= 0 ? (
            !searching ? (
              <TableRow>
                <TableCell colSpan={TABLE_HEAD_ITEMS.length}>
                  <NoSearch items="anuncios" />
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={TABLE_HEAD_ITEMS.length}>
                  <NoResults />
                </TableCell>
              </TableRow>
            )
          ) : (
            anuncios?.map((a: AnuncioDTO, index) => {
              const fechaDesde = a.fechaDesde
                ? format(parse(a.fechaDesde, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy', { locale: es })
                : null

              const fechaHasta = a.fechaHasta
                ? format(parse(a.fechaHasta, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy', { locale: es })
                : null
              return (
                <TableRow key={index}>
                  <TableCell>{a.idAnuncio}</TableCell>
                  <TableCell>{tiposAnucio.find((tipo) => tipo.id === a.idAnuncioTipo)?.nombre}</TableCell>
                  <TableCell>{anunciantes.find((item) => item.idAnunciante === a.idAnunciante)?.nombre}</TableCell>
                  <TableCell>{a.nombre}</TableCell>
                  <TableCell>
                    {fechaDesde && (
                      <>
                        Desde: {fechaDesde}
                        <br />
                      </>
                    )}
                    {fechaHasta && <>Hasta: {fechaHasta}</>}
                  </TableCell>
                  <TableCell>{a.activo ? 'Sí' : 'No'}</TableCell>
                  <TableCell sx={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                    <Button
                      disabled={loading}
                      variant="contained"
                      color="success"
                      onClick={() => handleUpdate(a.idAnuncio)}
                    >
                      Editar
                    </Button>
                    <Button
                      disabled={loading}
                      variant="contained"
                      color="error"
                      onClick={() => handleDelete(a.idAnuncio)}
                    >
                      Borrar
                    </Button>
                  </TableCell>
                </TableRow>
              )
            })
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablaServerPagination label="Anuncios por página" paginator={paginator} component={'td'} />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}

export default TablaAnuncios
